// Libs
import * as MobX from "mobx";
import { ModelBase } from "@shoothill/core";
import { IsNotEmpty, IsCurrency, IsPositive } from "class-validator";

// Dto
import { PropertyDetailPersonDTO } from "Globals/Models/DTO/PropertyDetailPersonDTO";

export class PersonModel extends ModelBase<PersonModel, PropertyDetailPersonDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public propertyDetailId: string = "";

    @IsNotEmpty({ message: "Name is required" })
    @MobX.observable
    public name: string = "";

    @IsNotEmpty({ message: "Gender is required" })
    @MobX.observable
    public gender: string | null = null;

    @IsNotEmpty({ message: "Date of birth is required" })
    @MobX.observable
    public dateOfBirth: Date | null = null;

    @IsNotEmpty({ message: "Relationship to you is required" })
    @MobX.observable
    public relationshipTypeId: string = "";

    @IsNotEmpty({ message: "Notes are required" })
    @MobX.observable
    public notes: string | null = null;

    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: PropertyDetailPersonDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.propertyDetailId = model.propertyDetailId;
            this.name = model.name;
            this.gender = model.gender;
            this.dateOfBirth = model.dateOfBirth;
            this.relationshipTypeId = model.relationshipTypeId;
            this.notes = model.notes;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): PropertyDetailPersonDTO => {
        let model: PropertyDetailPersonDTO = {
            id: this.id,
            propertyDetailId: this.propertyDetailId,
            name: this.name,
            gender: this.gender,
            dateOfBirth: this.dateOfBirth,
            relationshipTypeId: this.relationshipTypeId,
            notes: this.notes,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };
    @MobX.action
    public resetModel = (): void => {
        this.id = null;
        this.propertyDetailId = "";
        this.name = "";
        this.gender = null;
        this.dateOfBirth = new Date();
        this.relationshipTypeId = "";
        this.notes = "";
        this.createdDate = null;
        this.isDeleted = false;
    };
}
